module.exports = __webpack_public_path__ + "img/account-setting-icon-dark.06650cb7.svg";